import React from "react";

import { Modal } from "antd";

import { Alert } from "../../../../store/alerts/types";

import styles from "./styles.module.scss";

export interface AlertModalProps {
  alert: Alert;
  isLoading: boolean;
  handleOk: (id: number) => (e: React.MouseEvent<HTMLElement>) => void;
}

export const AlertModal: React.FC<AlertModalProps> = (props) => {
  const { alert, isLoading, handleOk } = props;

  const title = (
    <>
      <div className="ant-modal-title">{alert.title}</div>
      <div className={styles.date}>{alert.createdAt}</div>
    </>
  );

  return (
    <Modal
      visible
      centered
      title={title}
      closable={false}
      onOk={handleOk(alert.id)}
      confirmLoading={isLoading}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className={styles.description}>{alert.description}</div>
    </Modal>
  );
};
